import { resourceIdFromLayerOptions } from '@nextgis/ngw-kit';

import { Scene3DAdapter } from './Scene3DAdapter';

import type { GetClassAdapterOptions } from '@nextgis/ngw-kit';

export async function createScene3DAdapter(
  options: GetClassAdapterOptions,
): Promise<typeof Scene3DAdapter> {
  const resourceId = await resourceIdFromLayerOptions(
    options.layerOptions,
    options.connector,
  );
  return class NgwScene3DAdapter extends Scene3DAdapter {
    constructor(map: any) {
      super(map, {
        url: '',
        resourceId,
        ...options,
      });
    }
  };
}
